<template>
	<el-dialog
		:visible.sync="msgDetailVisible"
		width="50%"
		@closed="close"
	>
		<template v-slot:title>
			<div class="title">
				<div style="font-size: 18px;margin-bottom: 8px"> {{ detail.name || '通知' }}</div>
				<div style="font-size: 14px;margin-bottom: 10px">{{ detail.createTime }}</div>
			</div>
		</template>
		<div>
			<div class="msgDetailItem">
				{{ detail.text }}
			</div>
		</div>
	</el-dialog>
</template>

<script>
import {editMessageStatus} from '@/api/viewIndex';

export default {
	name: 'MessageDetail',
	data() {
		return {
			msgDetailVisible: false,
			detail: {},
		};
	},
	methods: {
		init(item) {
			console.log(item);
			this.detail = item;
			this.msgDetailVisible = true;
			this.read()
		},
		read() {
			editMessageStatus({
				id: this.detail.id
			}).then(res => {
				console.log(res);
				this.$emit('read');
			}).catch(err => {
				console.log(err);
			})
		},
		close() {
			this.msgDetailVisible = false;
		},
	},
};
</script>

<style scoped lang="scss">
.title {
	text-align: center;
	border-bottom: 1px solid #d6d3d3;
}
</style>
